import depotIcon from "assets/common/depotIcon.png";

const processPoints = (
  geometry:
    | google.maps.Data.Geometry
    | google.maps.LatLng
    | google.maps.Data.Point,
  callback: (arg: any) => void,
  thisArg: any,
) => {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry);
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get());
  } else {
    (geometry as any)
      .getArray()
      .forEach((g: google.maps.Data.Geometry) =>
        processPoints(g, callback, thisArg),
      );
  }
};

const setMapStyle = (map: google.maps.Map<Element>) => {
  map.data.setStyle({
    fillColor: "#000",
    fillOpacity: 0.5,
    strokeWeight: 0,
    icon: {
      url: depotIcon,
      scaledSize: new google.maps.Size(36, 40),
      anchor: new google.maps.Point(15.5, 20),
    },
  });
};

export const drawMap = (
  map: google.maps.Map<Element>,
  selectedAreaData: object,
  clear?: boolean,
) => {
  if (clear) map?.data.forEach((feature) => map?.data.remove(feature));

  map?.data.addGeoJson(selectedAreaData);

  const bounds = new google.maps.LatLngBounds();

  map.data.forEach((feature: google.maps.Data.Feature) => {
    processPoints(feature.getGeometry(), bounds.extend, bounds);
  });

  map.fitBounds(bounds);
  setMapStyle(map);
};
